import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { listMyRestaurants } from '../services/api';
import { storage } from '../utils/storage';
import './RestaurantSelector.css';

function RestaurantSelector() {
  const { t } = useTranslation();
  const [restaurants, setRestaurants] = useState([]);
  const [selectedRestaurantId, setSelectedRestaurantId] = useState('');
  const [allRestaurants, setAllRestaurants] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRestaurants();
    // Obtener restaurante seleccionado del localStorage
    const savedRestaurantId = storage.get('selectedRestaurantId');
    if (savedRestaurantId) {
      setSelectedRestaurantId(savedRestaurantId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadRestaurants = async () => {
    try {
      // Verificar que hay una organización seleccionada
      const organizationId = storage.get('selectedOrganizationId');
      if (!organizationId) {
        console.warn('No hay organización seleccionada');
        setLoading(false);
        return;
      }

      const data = await listMyRestaurants(organizationId);
      const activeRestaurants = (data.restaurants || []).filter(
        r => r.status === 'active' || r.status === 'inactive'
      );
      setRestaurants(activeRestaurants);
      setAllRestaurants(data.allRestaurants || false);

      // Si no hay restaurante seleccionado, seleccionar el primero activo
      const savedRestaurantId = storage.get('selectedRestaurantId');
      if (!savedRestaurantId && activeRestaurants.length > 0) {
        const firstActive =
          activeRestaurants.find(r => r.status === 'active') || activeRestaurants[0];
        handleRestaurantChange(firstActive.restaurantId);
      }
    } catch (error) {
      console.error('Error loading restaurants:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRestaurantChange = (restaurantId) => {
    setSelectedRestaurantId(restaurantId);
    storage.set('selectedRestaurantId', restaurantId);

    // Encontrar el restaurante seleccionado y guardar info adicional
    const restaurant = restaurants.find(r => r.restaurantId === restaurantId);
    if (restaurant) {
      storage.set('selectedRestaurantName', restaurant.name);
    }

    // Recargar la página para aplicar cambios
    window.location.reload();
  };

  if (loading) {
    return <div className="restaurant-selector loading">Cargando...</div>;
  }

  const organizationId = storage.get('selectedOrganizationId');
  if (!organizationId) {
    return (
      <div className="restaurant-selector empty">
        <span className="icon" role="img" aria-label={t('common.selectOrgFirst')}>⚠️</span>
        <span>{t('common.selectOrgFirst')}</span>
      </div>
    );
  }

  if (restaurants.length === 0) {
    return (
      <div className="restaurant-selector empty">
        <span className="icon">🏪</span>
        <span>No hay restaurantes</span>
      </div>
    );
  }

  const selectedRestaurant = restaurants.find(r => r.restaurantId === selectedRestaurantId);

  return (
    <div className="restaurant-selector">
      <span className="icon">🏪</span>
      <select
        value={selectedRestaurantId}
        onChange={e => handleRestaurantChange(e.target.value)}
        className="restaurant-select"
        aria-label={t('orders.selectRestaurant')}
      >
        <option value="">{t('orders.selectRestaurant')}</option>
        {restaurants.map(restaurant => (
          <option key={restaurant.restaurantId} value={restaurant.restaurantId}>
            {restaurant.name} {restaurant.status === 'inactive' ? '(Inactivo)' : ''}
          </option>
        ))}
      </select>
      {selectedRestaurant && (
        <span
          className="selected-restaurant-badge"
          title={selectedRestaurant.status === 'active' ? t('common.statusActive') : t('common.statusInactive')}
          aria-label={selectedRestaurant.status === 'active' ? t('common.statusActive') : t('common.statusInactive')}
        >
          {selectedRestaurant.status === 'active' ? '✓' : '⚠️'}
        </span>
      )}
      {allRestaurants && (
        <span className="all-access-badge" title="Acceso a todos los restaurantes">
          🔓
        </span>
      )}
    </div>
  );
}

export default RestaurantSelector;
